// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.EuTyEa33_9_XeXIQVIp7N {\n  margin: 2em auto;\n}\n\n._30aLK1aS8-MDuaza2uyVP0 {\n  display: flex;\n}\n\n._3idYu3X8Wt0uPgfVB9G5CS {\n  display: inline-block;\n  margin-right: 8px;\n}\n", ""]);
// Exports
exports.locals = {
	"container": "EuTyEa33_9_XeXIQVIp7N",
	"right-buttons": "_30aLK1aS8-MDuaza2uyVP0",
	"btn": "_3idYu3X8Wt0uPgfVB9G5CS"
};
module.exports = exports;
